import React, { useState } from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { Box, CssBaseline, Toolbar, Drawer } from '@mui/material';
import ProjectSidebar, { DRAWER_WIDTH } from './ProjectSidebar';
import TopBar from './TopBar';
import Dashboard from '../pages/Dashboard';
import Articles from '../pages/Articles';
import Ideas from '../pages/Ideas';
import Resources from '../pages/Resources';
import ImportJobs from '../pages/ImportJobs';
import VoiceStyle from '../pages/VoiceStyle';
import Audience from '../pages/Audience';
import Streams from '../pages/Streams';
import Settings from '../pages/Settings';
import Onboarding from '../pages/Onboarding';
import AppTutorial from './AppTutorial';
import Subscription from '../pages/Subscription';
import Media from '../pages/Media';
import ArticleCalendar from './ArticleCalendar';
import ArticleWizard from './wizard/ArticleWizard';

const AppContent = () => {
  const location = useLocation();
  const [mobileOpen, setMobileOpen] = useState(false);
  const isOnboarding = location.pathname === '/onboarding';
  const showBackButton = location.pathname !== '/articles';

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  if (isOnboarding) {
    return <Onboarding />;
  }

  return (
    <Box sx={{ display: 'flex' }}>
      <CssBaseline />
      <TopBar onMobileMenuToggle={handleDrawerToggle} />
      
      {/* Desktop sidebar */}
      <Box
        component="nav"
        sx={{ width: { sm: DRAWER_WIDTH }, flexShrink: { sm: 0 }, display: { xs: 'none', sm: 'block' } }}
      >
        <ProjectSidebar 
          mobileOpen={false}
          showBackButton={showBackButton}
        />
      </Box>

      {/* Mobile drawer */}
      <Drawer
        variant="temporary"
        open={mobileOpen}
        onClose={handleDrawerToggle}
        ModalProps={{
          keepMounted: true, // Better open performance on mobile.
        }}
        sx={{
          display: { xs: 'block', sm: 'none' },
          '& .MuiDrawer-paper': {
            boxSizing: 'border-box',
            width: DRAWER_WIDTH,
          },
        }}
      >
        <Toolbar /> {/* Add space for the AppBar */}
        <ProjectSidebar 
          mobileOpen={mobileOpen}
          onMobileClose={handleDrawerToggle}
          showBackButton={showBackButton}
        />
      </Drawer>

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          height: '100vh',
          overflow: 'auto',
          pt: '64px',
          backgroundColor: 'background.default',
          width: { xs: '100%', sm: `calc(100% - ${DRAWER_WIDTH}px)` },
        }}
      >
        <Routes>
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/sources/resources" element={<Resources />} />
          <Route path="/sources/streams" element={<Streams />} />
          <Route path="/sources/import" element={<ImportJobs />} />
          <Route path="/ideas" element={<Ideas />} />
          <Route path="/articles/*" element={<Articles />} />
          <Route path="/brandvoice/style" element={<VoiceStyle />} />
          <Route path="/brandvoice/audience" element={<Audience />} />
          <Route path="/media" element={<Media />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/subscription" element={<Subscription />} />
          <Route path="/calendar" element={<ArticleCalendar />} />
          <Route path="/create-article" element={<ArticleWizard />} />
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </Box>
      <AppTutorial />
    </Box>
  );
};

export default AppContent; 